"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonVariants = exports.ButtonVariantType = exports.ButtonVariant = void 0;
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
function cov_2dq672zf7() {
  var path = "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/types.js";
  var hash = "966caa23a5831d8f41a42cc4fb37b19d63e690f4";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/types.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 10
        },
        end: {
          line: 4,
          column: 23
        }
      },
      "1": {
        start: {
          line: 9,
          column: 30
        },
        end: {
          line: 9,
          column: 66
        }
      },
      "2": {
        start: {
          line: 14,
          column: 29
        },
        end: {
          line: 14,
          column: 72
        }
      },
      "3": {
        start: {
          line: 16,
          column: 33
        },
        end: {
          line: 16,
          column: 64
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "966caa23a5831d8f41a42cc4fb37b19d63e690f4"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2dq672zf7 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2dq672zf7();
var _ = (cov_2dq672zf7().s[0]++, {
  zipObject: _lodash.zipObject
});

/**
 * @type {['primary', 'secondary', 'tertiary']}
 */
var buttonVariants = exports.buttonVariants = (cov_2dq672zf7().s[1]++, ['primary', 'secondary', 'tertiary']);

/**
 * @type {{ primary: 'primary', secondary: 'secondary', tertiary: 'tertiary' }}
 */
var ButtonVariant = exports.ButtonVariant = (cov_2dq672zf7().s[2]++, _.zipObject(buttonVariants, buttonVariants));
var ButtonVariantType = exports.ButtonVariantType = (cov_2dq672zf7().s[3]++, _propTypes.default.oneOf(buttonVariants));